export default "<span [onHoverDescribe]=\"detail\">...</span>"